<template>
  <div class="list-drawer" :class="{ 'is-detailed': isDetailedView }">
    <QuickMoveInListGrid v-if="!isDetailedView" />
    <QuickMoveInListDetail v-if="isDetailedView" />
  </div>
</template>

<script>
import { uuidv4 } from '@/helpers/ui';
import QuickMoveInListGrid from '@/components/QuickMoveInListGrid';
import QuickMoveInListDetail from '@/components/QuickMoveInListDetail';

export default {
  name: 'QuickMoveInListDrawer',
  components: {
    QuickMoveInListDetail,
    QuickMoveInListGrid,
  },
  computed: {
    uuid() {
      return uuidv4();
    },
    isDetailedView() {
      return this.$store.getters['ui/getPanelView'] === 'detail';
    },
  },
  methods: {
    showMap() {
      console.log('QuickMoveInListDrawer showMap()');
      this.$store.dispatch('ui/setMapDisplay', { mapDisplay: true });
    },
  },
};
</script>
